import React from "react";

import { Stack, Typography } from "@mui/material";

interface Props {
  deals_in?: number;
  deals_out?: number;
}

const chipSx = {
  height: "24px",
  display: "flex",
  alignItems: "center",
  px: "8px",
  borderRadius: "20px",
  bgcolor: "#f6f8fc",
  fontSize: "12px",
  lineHeight: "16px",
  whiteSpace: "nowrap"
} as const;

/**
 * In/out counters shown under a stage header in Diff view (Figma node 2701:67288). Rendered only when the
 * backend included the counters — they are present exclusively when `show_stage_diff` was requested, so
 * presence alone gates the row (no separate diff flag needed). Green `+N in`, red `−N out`.
 */
export const StageDiffCounters: React.FC<Props> = ({ deals_in, deals_out }) => {
  if (deals_in === undefined && deals_out === undefined) return null;

  return (
    <Stack direction="row" gap="10px" sx={{ pt: "4px" }}>
      <Typography sx={{ ...chipSx, color: "#07a27d" }}>+{deals_in ?? 0} in</Typography>
      <Typography sx={{ ...chipSx, color: "#d93e3e" }}>-{deals_out ?? 0} out</Typography>
    </Stack>
  );
};
